import Component from '@glimmer/component';
import { service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  contactId: string;
}

export default class FilterContactComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  get contact() {
    return this.contactsCache.getById(this.args.contactId);
  }
}
